import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var Globe05 = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "globe05",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M15 2.4578A9.9956 9.9956 0 0 0 12 2C6.4771 2 2 6.4771 2 12c0 5.5228 4.4771 10 10 10 5.5228 0 10-4.4772 10-10 0-1.7153-.4319-3.3298-1.1929-4.7405M17 5.75h.005m-6.5049 16.1383.0001-2.2034a.5001.5001 0 0 1 .1203-.3253l2.4858-2.9002c.2043-.2383.141-.6038-.1315-.7595l-2.8563-1.6322a.499.499 0 0 1-.1862-.1863l-1.8618-3.2628a.5.5 0 0 0-.4787-.2502l-5.5276.4923M21 6c0 2.2091-2 4-4 6-2-2-4-3.7909-4-6s1.7909-4 4-4c2.2091 0 4 1.7909 4 4Zm-3.75-.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    })
  }));
};
export default Globe05;